import React from 'react'
import { useHistory } from 'react-router'

import { Routes } from '../../Routes'
import { getAccounts } from '../../lib/api'
import { setStoredAccount } from '../AccountProvider'

export const LoginStateContext = React.createContext(null)

export const STATES = {
  LOGIN: 0,
  NEW_PASSWORD: 1,
  FORGOT_PASSWORD: 2,
  MFA: 3,
  NO_ACCOUNTS: 4
}

const LoginStateProvider = ({ children }) => {
  const history = useHistory()

  const [state, setState] = React.useState(STATES.LOGIN)
  const [email, setEmail] = React.useState('')

  const [isLoggedIn, setIsLoggedIn] = React.useState(false)
  const [environment, setEnvironment] = React.useState(false)
  const [selectEnv, setSelectEnv] = React.useState(false)
  const [accounts, setAccounts] = React.useState([])
  const [accountError, setAccountError] = React.useState(null)

  const redirectToAccounts = React.useCallback(
    async message => {
      setAccountError(message)
      setStoredAccount(null)

      // Simulate login, but show accounts screen
      setEnvironment(true)
      setIsLoggedIn(true)
      setSelectEnv(false)

      // Update accounts
      try {
        const accounts = await getAccounts()
        setAccounts(accounts)
      } catch (err) {
        console.error('Error getting accounts')
        setAccounts([])
      }

      history.replace(Routes.LOGIN)
    },
    [history]
  )

  return (
    <LoginStateContext.Provider
      value={{
        state,
        setState,
        setEmail,
        email,
        isLoggedIn,
        setIsLoggedIn,
        environment,
        setEnvironment,
        selectEnv,
        setSelectEnv,
        accounts,
        setAccounts,
        accountError,
        setAccountError,
        redirectToAccounts
      }}
    >
      {children}
    </LoginStateContext.Provider>
  )
}

export default LoginStateProvider

export const useLoginState = () => React.useContext(LoginStateContext)
